module.exports = __webpack_public_path__ + "static/media/edit.2dda1c36.svg";